export const siteInfo = {
  name: '桔子视频',
  tagline: '全网热门视频聚合',
  h1: '桔子视频 - 高清视频在线观看平台',
  slogan: '搜索即看，流畅不缓冲',
  description: '桔子视频精心收录91视频网站、久久视频、菠萝视频等全网热门视频资源，覆盖电视剧、电影、综艺、动漫等多类型内容。每日同步更新最新剧集与大片，91在线视频高清免费在线观看，无需下载、无需注册，打开即看。我们持续优化播放体验，确保全集资源流畅不缓冲，让每一位影迷都能享受极致的在线观影乐趣。',
  stats: [
    { label: '每日更新', value: '200+' },
    { label: '高清片源', value: '10万+' },
    { label: '流畅播放', value: '99.9%' },
  ],
  ctaPrimary: { text: '立即观影', href: '#ranking' },
  ctaSecondary: { text: '了解更多', href: '#features' },
};

export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '热门排行', href: '#ranking' },
  { label: '专题推荐', href: '#cards' },
  { label: '焦点专题', href: '#carousel' },
  { label: '常见问题', href: '#faq' },
  { label: '联系我们', href: '#contact' },
];

export const faqItems = [
  {
    question: '桔子视频是否需要注册或付费？',
    answer: '完全不需要。桔子视频所有91视频网站、久久视频等资源均为免费在线观看，无需注册账号，无需支付任何费用，打开网站即可畅享高清视频内容。',
  },
  {
    question: '91在线视频和菠萝视频的资源是否同步更新？',
    answer: '是的，我们每日同步更新91在线视频和菠萝视频的最新内容，电视剧全集、电影大片均与源站保持同步，确保您第一时间看到最新剧集。',
  },
  {
    question: '观看高清视频会不会出现卡顿缓冲？',
    answer: '桔子视频采用多线路智能调度技术，自动为您匹配最优播放节点。经过持续优化，99.9%的视频均可实现流畅不缓冲的高清播放体验。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '桔子视频全面适配电脑、平板和手机端，无论使用 Chrome、Safari 还是手机自带浏览器，均可获得一致的高清观影体验，随时随地想看就看。',
  },
];

export const rankingItems = [
  { rank: 1, title: '狂飙', category: '电视剧', heat: '9.8', tag: '热播中', desc: '扫黑除恶题材年度爆款剧集，张译张颂文演技炸裂' },
  { rank: 2, title: '流浪地球2', category: '电影', heat: '9.6', tag: '科幻大片', desc: '国产科幻里程碑续作，视觉特效全面升级' },
  { rank: 3, title: '长风渡', category: '电视剧', heat: '9.5', tag: '新剧上线', desc: '白敬亭宋轶古装甜宠，热度持续攀升中' },
  { rank: 4, title: '满江红', category: '电影', heat: '9.4', tag: '悬疑喜剧', desc: '张艺谋执导，沈腾易烊千玺领衔主演' },
  { rank: 5, title: '三体', category: '电视剧', heat: '9.3', tag: '科幻巨制', desc: '刘慈欣原著改编，国产科幻剧集新标杆' },
  { rank: 6, title: '独行月球', category: '电影', heat: '9.2', tag: '喜剧科幻', desc: '沈腾马丽黄金搭档，开心麻花科幻喜剧' },
];

export const mediaItems = [
  { title: '最新电视剧《繁花》全集上线', cover: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20Shanghai%20cityscape%20neon%20lights%201990s%20aesthetic%20warm%20glow%20cinematic%20composition%20with%20retro%20vibe%20and%20elegant%20atmosphere&width=640&height=360&seq=media-01&orientation=landscape', duration: '全30集', tag: '热播' },
  { title: '《封神第一部》高清完整版', cover: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20fantasy%20film%20scene%20with%20ancient%20warriors%20dramatic%20sky%20golden%20and%20crimson%20tones%20cinematic%20lighting%20grand%20scale&width=640&height=360&seq=media-02&orientation=landscape', duration: '148分钟', tag: '推荐' },
  { title: '《莲花楼》古装武侠热播中', cover: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20drama%20scene%20ancient%20temple%20misty%20mountains%20elegant%20swordsman%20flowing%20robes%20warm%20sunlight%20through%20bamboo%20forest&width=640&height=360&seq=media-03&orientation=landscape', duration: '更新至36集', tag: '热播' },
  { title: '《消失的她》悬疑力作', cover: 'https://readdy.ai/api/search-image?query=Mysterious%20suspense%20thriller%20atmosphere%20tropical%20island%20night%20scene%20dark%20ocean%20moonlight%20silhouette%20palms%20dramatic%20shadows%20cinematic&width=640&height=360&seq=media-04&orientation=landscape', duration: '122分钟', tag: '热门' },
  { title: '《长相思》古装仙侠全集', cover: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20drama%20ethereal%20goddess%20flowing%20silk%20cherry%20blossoms%20ancient%20palace%20soft%20pink%20and%20gold%20warm%20magical%20atmosphere&width=640&height=360&seq=media-05&orientation=landscape', duration: '全39集', tag: '完结' },
];

export const appItem = {
  title: '桔子视频移动端 - 随时随地高清观影',
  subtitle: '无需下载APP，手机浏览器直接访问，即点即看',
  features: ['全平台适配', '流量节省模式', '夜间观影模式', '继续观看记录'],
  qrcode: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20mobile%20phone%20displaying%20video%20streaming%20interface%20with%20movie%20thumbnails%20warm%20orange%20accent%20on%20clean%20white%20background%20flat%20design&width=400&height=400&seq=app-qr-01&orientation=squarish',
};

export const featureItems = [
  { icon: 'ri-4k-line', title: '高清画质', desc: '支持1080P超清播放，91视频网站资源高品质呈现，画质锐利细节丰富' },
  { icon: 'ri-speed-up-line', title: '极速加载', desc: '多CDN节点智能加速，久久视频等热门资源秒开不等待' },
  { icon: 'ri-smartphone-line', title: '全端适配', desc: '电脑、平板、手机完美兼容，菠萝视频随时随地畅快观看' },
  { icon: 'ri-refresh-line', title: '每日更新', desc: '91在线视频同步更新，新剧热片第一时间上线不遗漏' },
  { icon: 'ri-shield-check-line', title: '安全无广告', desc: '纯净观影环境，无弹窗无恶意跳转，专注高清在线观看体验' },
];

export const cardItems = [
  { title: '国产剧热播专区', desc: '精选年度口碑国产剧集，从古装仙侠到都市情感，高清全集一次看够', image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20palace%20scene%20elegant%20costumes%20warm%20lantern%20light%20traditional%20architecture%20soft%20golden%20hour%20cinematic%20composition&width=640&height=400&seq=card-01&orientation=landscape', tag: '热门' },
  { title: '好莱坞大片合集', desc: '漫威、DC、速度与激情系列，好莱坞商业大片高清中字完整版', image: 'https://readdy.ai/api/search-image?query=Hollywood%20blockbuster%20cinematic%20scene%20epic%20action%20cityscape%20explosion%20dramatic%20orange%20sky%20hero%20silhouette%20wide%20angle%20lens%20flare&width=640&height=400&seq=card-02&orientation=landscape', tag: '精选' },
  { title: '日韩剧集精选', desc: '最新日剧韩剧同步跟播，高分神作一网打尽，字幕精准追剧无忧', image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20romantic%20scene%20cherry%20blossom%20tree%20sunset%20couple%20walking%20warm%20pastel%20tones%20soft%20bokeh%20cinematic%20feel&width=640&height=400&seq=card-03&orientation=landscape', tag: '更新中' },
  { title: '国产动漫崛起', desc: '斗罗大陆、完美世界、凡人修仙传，国漫精品持续更新中', image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20fantasy%20martial%20arts%20scene%20glowing%20energy%20ancient%20warrior%20dynamic%20pose%20vibrant%20red%20and%20gold%20colors%20epic%20scale&width=640&height=400&seq=card-04&orientation=landscape', tag: '国漫' },
  { title: '综艺娱乐大全', desc: '奔跑吧、向往的生活、脱口秀大会，热门综艺高清完整版随时回看', image: 'https://readdy.ai/api/search-image?query=Variety%20show%20stage%20colorful%20lighting%20spotlights%20energetic%20atmosphere%20warm%20stage%20design%20entertainment%20studio%20set%20bright%20vibrant&width=640&height=400&seq=card-05&orientation=landscape', tag: '热播' },
];

export const topicItems = [
  { tag: '狂飙结局', heat: '128万' },
  { tag: '繁花沪语版', heat: '96万' },
  { tag: '流浪地球3', heat: '87万' },
  { tag: '91在线视频', heat: '76万' },
  { tag: '菠萝视频更新', heat: '65万' },
  { tag: '三体第二季', heat: '58万' },
  { tag: '久久视频高清', heat: '52万' },
  { tag: '古装仙侠剧', heat: '45万' },
  { tag: '悬疑剧推荐', heat: '38万' },
  { tag: '周末刷剧清单', heat: '32万' },
];

export const carouselItems = [
  {
    title: '2024年度必看国产剧',
    subtitle: '口碑与热度齐飞，这些剧你追了几部？',
    desc: '从年初的《繁花》到年末的《我是刑警》，2024年国产剧市场百花齐放，悬疑、古装、都市情感各类型佳作频出。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20TV%20drama%20collage%20style%20various%20scenes%20modern%20and%20historical%20warm%20cinematic%20tones%20rich%20textures%20golden%20and%20crimson%20accents%20elegant%20composition&width=800&height=500&seq=carousel-01&orientation=landscape',
    tag: '年度盘点',
  },
  {
    title: '高分悬疑片单推荐',
    subtitle: '烧脑反转，每一部都让你欲罢不能',
    desc: '精选国内外高分悬疑佳作，《消失的她》《沉默的真相》《隐秘的角落》等口碑神作，带你体验极致的推理快感。',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20atmosphere%20dark%20rainy%20alley%20neon%20reflection%20on%20wet%20pavement%20noir%20style%20deep%20shadows%20dramatic%20contrast%20warm%20street%20lamp%20glow&width=800&height=500&seq=carousel-02&orientation=landscape',
    tag: '悬疑片单',
  },
  {
    title: '科幻迷不可错过的神作',
    subtitle: '从《三体》到《流浪地球》，国产科幻崛起之路',
    desc: '中国科幻影视正在经历前所未有的黄金时代，大制作、强特效、硬核故事，让世界看到了东方科幻的独特魅力。',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20cityscape%20massive%20spaceship%20holographic%20displays%20warm%20amber%20and%20teal%20lighting%20epic%20scale%20cinematic%20composition%20stars%20in%20background&width=800&height=500&seq=carousel-03&orientation=landscape',
    tag: '科幻专题',
  },
  {
    title: '经典港片修复重映',
    subtitle: '那些年我们追过的港片，高清修复版重温经典',
    desc: '周星驰喜剧、成龙动作、王家卫文艺，港片黄金年代的经典作品经过高清修复，以全新画质呈现，情怀满满。',
    image: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20cinema%20nostalgic%20scene%20neon%20signs%20Kowloon%20street%20vintage%20aesthetic%20warm%20tones%20rain%20reflections%20cinematic%20noir%20style%201990s%20atmosphere&width=800&height=500&seq=carousel-04&orientation=landscape',
    tag: '经典重温',
  },
  {
    title: '古装仙侠剧进化史',
    subtitle: '从《仙剑》到《长相思》，仙侠美学二十年的变迁',
    desc: '仙侠剧作为国产剧最重要的类型之一，在服化道、特效和叙事上经历了翻天覆地的变化，让我们一同回顾这段奇幻旅程。',
    image: 'https://readdy.ai/api/search-image?query=Ethereal%20Chinese%20fantasy%20landscape%20floating%20mountains%20waterfalls%20ancient%20temple%20mist%20magical%20glow%20soft%20pastel%20colors%20dreamlike%20atmosphere%20celestial%20beings&width=800&height=500&seq=carousel-05&orientation=landscape',
    tag: '类型进化',
  },
  {
    title: '春节档电影抢先看',
    subtitle: '合家欢、喜剧、动画，春节档观影指南来了',
    desc: '每年春节档都是华语电影最激烈的战场，我们整理了即将上映的春节档大片信息，助你提前规划假期观影清单。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20New%20Year%20festive%20cinema%20scene%20red%20lanterns%20fireworks%20warm%20celebratory%20atmosphere%20family%20gathering%20golden%20and%20red%20tones%20joyful%20composition&width=800&height=500&seq=carousel-06&orientation=landscape',
    tag: '春节档',
  },
];

export const commentItems = [
  { name: '影迷小王', avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%20casual%20style%20warm%20smile%20clean%20white%20background%20professional%20headshot&width=80&height=80&seq=avatar-01&orientation=squarish', rating: 5, content: '桔子视频真的太方便了！资源更新快，画质清晰，不用下载任何APP就能看，追剧神器无疑了。91视频网站的资源这里基本都有。', time: '2天前' },
  { name: '追剧达人', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20portrait%20modern%20stylish%20warm%20expression%20clean%20white%20background%20professional%20headshot&width=80&height=80&seq=avatar-02&orientation=squarish', rating: 5, content: '同事推荐来的，久久视频和菠萝视频每天同步更新，周末一口气刷完了《莲花楼》全集，全程高清不卡顿，体验满分。', time: '3天前' },
  { name: '电影爱好者', avatar: 'https://readdy.ai/api/search-image?query=Middle%20aged%20Chinese%20man%20portrait%20glasses%20warm%20smile%20clean%20white%20background%20professional%20headshot&width=80&height=80&seq=avatar-03&orientation=squarish', rating: 4, content: '片源很全，从老港片到最新漫威都有。91在线视频的播放速度也很稳定，用手机看完全不卡，已经推荐给身边朋友了。', time: '5天前' },
  { name: '剧荒拯救者', avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20trendy%20fashion%20warm%20look%20clean%20white%20background%20professional%20headshot&width=80&height=80&seq=avatar-04&orientation=squarish', rating: 5, content: '每天都有新内容更新，专题做得也很用心，帮我在茫茫片海中找到了不少好剧。菠萝视频的资源更新速度和源站几乎同步。', time: '1周前' },
  { name: '深夜刷剧人', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20portrait%20relaxed%20casual%20hoodie%20warm%20expression%20clean%20white%20background%20professional%20headshot&width=80&height=80&seq=avatar-05&orientation=squarish', rating: 5, content: '夜间模式很贴心，看久了眼睛不累。关键是免费无广告，这在现在的视频网站里太难得了。久久视频的资源这里都有。', time: '1周前' },
];

export const updateItems = [
  { date: '2026-07-31', content: '《狂飙》全集高清修复版上线，画质全面升级', tag: '资源更新' },
  { date: '2026-07-30', content: '新增91视频网站最新剧集同步通道，更新速度提升50%', tag: '功能升级' },
  { date: '2026-07-29', content: '菠萝视频独家片单「暑期必看50部」专题上线', tag: '专题上新' },
  { date: '2026-07-28', content: '播放器全面升级，支持记忆播放与倍速切换', tag: '体验优化' },
  { date: '2026-07-27', content: '久久视频经典港片修复系列新增《无间道》三部曲', tag: '资源更新' },
  { date: '2026-07-26', content: '移动端适配优化，手机观影流量消耗降低30%', tag: '体验优化' },
  { date: '2026-07-25', content: '91在线视频热门综艺《奔跑吧》最新季全集上线', tag: '资源更新' },
  { date: '2026-07-24', content: '新增「猜你喜欢」智能推荐模块，找片更轻松', tag: '功能升级' },
];

export const indexItems = [
  { letter: 'A', title: '爱情片', count: '326部', desc: '浪漫爱情、青春校园，感人至深的爱情故事合集' },
  { letter: 'B', title: '动作片', count: '518部', desc: '热血格斗、惊险追逐，肾上腺素飙升的动作盛宴' },
  { letter: 'C', title: '喜剧片', count: '442部', desc: '爆笑喜剧、轻松解压，欢乐不断笑声不停的精选合集' },
  { letter: 'D', title: '电视剧', count: '890部', desc: '国产剧、韩剧、美剧，热门电视剧高清全集追不停' },
  { letter: 'E', title: '动漫番剧', count: '675部', desc: '国漫崛起、日漫经典，二次元世界的无限精彩' },
  { letter: 'F', title: '综艺娱乐', count: '368档', desc: '脱口秀、真人秀、音乐竞演，热门综艺持续更新' },
  { letter: 'G', title: '纪录片', count: '203部', desc: '自然、历史、人文，开阔视野的高品质纪录片' },
  { letter: 'H', title: '科幻片', count: '287部', desc: '硬核科幻、未来想象，震撼视效的科幻电影大全' },
  { letter: 'I', title: '悬疑片', count: '394部', desc: '烧脑反转、细思极恐，让人欲罢不能的悬疑佳作' },
];

export const contactItem = {
  title: '联系我们',
  subtitle: '如有资源建议、内容合作或问题反馈，欢迎通过以下方式与我们取得联系',
  email: 'feedback@juzivideo.com',
  wechat: 'juzivideo2024',
  qq: '1234567890',
  tip: '我们会在24小时内回复您的留言',
};

export const aboutItem = {
  title: '关于桔子视频',
  content: '桔子视频是一个致力于为用户提供高清在线视频观看服务的综合平台。我们聚合91视频网站、久久视频、菠萝视频等优质视频资源，每日同步更新最新电视剧、电影、综艺、动漫内容。无需下载、无需注册，打开即可畅享全集高清观影体验。我们始终坚持以用户体验为核心，持续优化播放技术，确保91在线视频等热门内容流畅不缓冲，让每一位用户都能享受到极致的在线观影乐趣。',
};

export const footerPartners = {
  title: '合作伙伴',
  description: '桔子视频与多家优质视频内容平台保持良好合作关系，共同为用户提供丰富的在线观影选择。',
};